// extracted by mini-css-extract-plugin
module.exports = {"button-white":"ButtonTitle_button-white___TXuD","button-text":"ButtonTitle_button-text__wy4sE"};